<template>
    <div class="profileform">
        <div class="content">
            <h2 v-if="!hasProfile" class="is-size-4">Skapa en konstnärsprofil för att komma igång. </h2>
            <h2 v-if="hasProfile" class="is-size-4">Redigera din profil</h2>
        </div>
        <form>
            <div class="columns">
                <div class="field column is-half mb-0 pb-0">
                    <label class="label">Förnamn</label>
                    <div class="control">
                        <input v-model="profileData.firstName" class="input" type="text" placeholder="">
                    </div>
                </div>
                <div class="field column is-half mb-0 pb-0">
                    <label class="label">Efternamn</label>
                    <div class="control">
                        <input v-model="profileData.lastName" v-on:change="getSlug()" class="input" type="text" placeholder="">
                    </div>
                </div>
            </div>
            <div class="field">
                <label class="label">Ort</label>
                <div class="control">
                    <input v-model="profileData.city" class="input" type="text" placeholder="">
                </div>
            </div>
            <div class="field">
                <label class="label">Land</label>
                <div class="control">
                    <input class="input" type="text" placeholder="" value="Sverige" disabled>
                </div>
            </div>
            <div class="field">
                <label class="label">Titel</label>
                <div class="control">
                    <input v-model="profileData.title" class="input" type="text" placeholder="">
                </div>
            </div>
            <div class="field">
                <label class="label">Hemsida</label>
                <div class="control">
                    <input v-model="profileData.homepage" class="input" type="text" placeholder="">
                </div>
                <p class="help">Ange en hemsida eller profilsida på sociala medier som beskriver dig och ditt arbete.</p>
            </div>
            <div class="field">
                <div class="control" v-bind:class="{'is-loading': loading }">
                    <button v-on:click.prevent="saveProfile" class="button is-link" v-bind:disabled="submitted">Skicka</button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
//import faunadb, { query as q } from "faunadb";

export default {
    name: "ProfileForm",
    props: [],
    data: () => (
        {
        profileData: {},
        loading: false,
        submitted: false
    }),
    computed: {
        hasProfile() {
            return this.$store.getters.hasProfile;
        }
    },
    methods: {
        async getSlug() {
           let res = await this.$store.dispatch("api/get",`utils/text/slugify?text=${this.profileData.firstName}+${this.profileData.lastName}`);
           this.profileData.slug = res.data.result;
        },
        async saveProfile() {
            //validate form
            if(!this.profileData.firstName || !this.profileData.lastName || !this.profileData.homepage)
                return;
            //get slug
            //save data
            this.submitted = true;
            this.loading = true;
            //const token = this.$store.state.token;
            //const client = new faunadb.Client({ secret: token });
            try {
                if(!this.profileData.slug) {
                    await this.getSlug();
                }
                if("homepage" in this.profileData && !this.profileData.homepage.startsWith("http")) {
                    this.profileData.homepage = "http://" + this.profileData.homepage; 
                }
                let profile = await this.$store.dispatch("save_profile", this.profileData);
                //let profile = await client.query(q.Call('saveProfile', this.profileData));
                this.$data.profile = JSON.parse(JSON.stringify(profile));
                this.loading = false;
                this.submitted = false;
            } catch(err) {
                // catch
                console.log(err);
            }
        }
    },
    async created() {
        this.loading = true;
        await this.$store.dispatch("load_user");
        this.profileData = JSON.parse(JSON.stringify(await this.$store.getters.getProfile)) || {};
        this.loading = false;
    },
    
}
</script>

<style scoped>
.instruction { display: block; clear: both;}
</style>